import { camelCase } from '@bettermode/common/camelcase'
import { startCase } from '@bettermode/common/startcase'

export const toI18nMessageId = (...inputs: string[]) => {
  return inputs
    .map(input => startCase(camelCase(input)).replace(/ /g, ''))
    .join('.')
}
